import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from '..';
import * as fromStaffEvent from './staff-event.reducer';

// feature selectors
const getSharedAuditState = createFeatureSelector<State>('sharedAudit');

// feature slice - staffEvent
const getStaffEventSubState = createSelector(getSharedAuditState, state => state.staffEvent);

// staffEvent slice selectors
const getStaffEventSkeletonsState = createSelector(
  getStaffEventSubState,
  state => state.staffEventSkeletons
);
const getStaffEventAuditState = createSelector(
  getStaffEventSubState,
  state => state.staffEventAudit
);
const getStaffEventBusinessPersonAuditState = createSelector(
  getStaffEventSubState,
  state => state.staffEventBusinessPersonAudit
);
const getScheduledEventAuditState = createSelector(
  getStaffEventSubState,
  state => state.scheduledEventAudit
);
const getStaffEventTypeState = createSelector(getStaffEventSubState, state => state.staffEventType);

// staffEvent skeletons
export const getStaffEventSkeletonsLoaded = createSelector(
  getStaffEventSkeletonsState,
  state => state.loaded
);
export const getStaffEventSkeletonsLoading = createSelector(
  getStaffEventSkeletonsState,
  state => state.loading
);
// const getStaffEventSkeletonsError = createSelector(
//   getStaffEventSkeletonsState,
//   state => state.error
// );
// const getStaffEventSkeletons = createSelector(
//   getStaffEventSkeletonsState,
//   getStaffEventSkeletonsLoaded,
//   (state, isLoaded) => {
//     return isLoaded ? state.entities : null;
//   }
// );
export const getStaffEventAuditSkeletons = createSelector(
  getStaffEventSkeletonsState,
  fromStaffEvent.staffEventSkeletonSelectors.selectAll
);

// staffevent audits
export const getStaffEventAuditLoaded = createSelector(
  getStaffEventAuditState,
  state => state.loaded
);
export const getStaffEventAuditLoading = createSelector(
  getStaffEventAuditState,
  state => state.loading
);
export const getStaffEventAudits = createSelector(
  getStaffEventAuditState,
  fromStaffEvent.staffEventAuditSelectors.selectAll
);

// staffevent businessperson audits
export const getStaffEventBusinessPersonAuditLoaded = createSelector(
  getStaffEventBusinessPersonAuditState,
  state => state.loaded
);
export const getStaffEventBusinessPersonAuditLoading = createSelector(
  getStaffEventBusinessPersonAuditState,
  state => state.loading
);
export const getStaffEventBusinessPersonAudits = createSelector(
  getStaffEventBusinessPersonAuditState,
  fromStaffEvent.staffEventBusinessPersonAuditSelectors.selectAll
);

// scheduledevent audits
export const getScheduledEventAuditLoaded = createSelector(
  getScheduledEventAuditState,
  state => state.loaded
);
export const getScheduledEventAuditLoading = createSelector(
  getScheduledEventAuditState,
  state => state.loading
);
export const getScheduledEventAudits = createSelector(
  getScheduledEventAuditState,
  fromStaffEvent.scheduledEventAuditSelectors.selectAll
);

// staffEventType selectors
export const getStaffEventTypesLoaded = createSelector(
  getStaffEventTypeState,
  state => state.loaded
);
export const getStaffEventTypesLoading = createSelector(
  getStaffEventTypeState,
  state => state.loading
);
export const getStaffEventTypes = createSelector(
  getStaffEventTypeState,
  fromStaffEvent.staffEventTypeSelectors.selectAll
);
